import { render } from "./AppointmentForm.vue?vue&type=template&id=cbc0eddc&scoped=true"
import script from "./AppointmentForm.vue?vue&type=script&lang=js"
export * from "./AppointmentForm.vue?vue&type=script&lang=js"

import "./AppointmentForm.vue?vue&type=style&index=0&id=cbc0eddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbc0eddc"]])

export default __exports__